import React from "react";
import { ScoringBreakdownItem } from "../types";

interface Props {
  breakdown: ScoringBreakdownItem[];
  totalScore: number | null;
}

const FACTOR_LABELS: Record<string, string> = {
  naics_match: "NAICS Match",
  geographic_match: "Geographic",
  contract_value: "Value Fit",
  past_performance: "Past Perf.",
  set_aside: "Set-Aside",
  response_deadline: "Deadline",
  agency_history: "Agency Hx",
  keyword_relevance: "Keywords",
};

function ScoringBreakdown({ breakdown, totalScore }: Props) {
  return (
    <div>
      <div style={{
        display: "flex", justifyContent: "space-between", alignItems: "center",
        marginBottom: "12px",
      }}>
        <span style={{ fontWeight: 600, fontSize: "14px", color: "#2c3e50" }}>
          Gate 2 Score
        </span>
        <span style={{
          fontSize: "20px", fontWeight: 700,
          color: (totalScore ?? 0) >= 55 ? "#27ae60" : "#e67e22",
        }}>
          {totalScore ?? 0}/100
        </span>
      </div>
      {breakdown.map((item) => {
        const pct = item.points_max > 0 ? (item.points_earned / item.points_max) * 100 : 0;
        return (
          <div key={item.factor} style={{ marginBottom: "8px" }}>
            <div style={{
              display: "flex", justifyContent: "space-between",
              fontSize: "12px", color: "#666", marginBottom: "2px",
            }}>
              <span>{FACTOR_LABELS[item.factor] || item.factor}</span>
              <span>{item.points_earned}/{item.points_max}</span>
            </div>
            <div style={{
              height: "6px", backgroundColor: "#ecf0f1", borderRadius: "3px",
              overflow: "hidden",
            }}>
              <div style={{
                height: "100%", borderRadius: "3px",
                width: `${pct}%`,
                backgroundColor: pct >= 70 ? "#27ae60" : pct >= 40 ? "#f39c12" : "#e74c3c",
                transition: "width 0.3s ease",
              }} />
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default ScoringBreakdown;
